module.exports = __webpack_public_path__ + "img/tz.8ef4cacd.svg";